module.exports = __webpack_public_path__ + "img/index-section6-friend4.73893051.svg";